<template>
  <div id="AccountCompany" class="Main-Content">
    <ValidationObserver v-slot="{ invalid }" slim>
      <LoadingLayout v-if="loading" :page="true" />

      <Page
        v-else
        :title="$t('Company')"
        :primaryAction="{
          label: $t('Save'),
          onAction: save,
          disabled: invalid || saving
        }"
        :secondaryActions="[{
          label: $t('Notes'),
          onAction: () => eventHub.$emit('showAccountNotes', 'ACCOUNT')
        }]"
      >

        <Layout>
          <LayoutSection>
            <Card :title="$t('Company Information')">
              <CardSection>
                <FormLayout>
                  <validation-provider :name="$t('Name')" immediate rules="required" v-slot="{ errors }">
                    <TextField  
                      :label="$t('Name')"
                      v-model="account.name"
                      :error="errors[0]"
                    />
                  </validation-provider>

                  <TextField
                    :label="$t('Address')"
                    v-model="account.address1"
                  />
                  
                  <FormLayoutGroup>
                    <TextField
                      :label="$t('City')"
                      v-model="account.city"
                    />

                    <TextField
                      :label="$t('State')"
                      v-model="account.state"
                    />
                  </FormLayoutGroup>

                  <FormLayoutGroup>
                    <Select
                      :label="$t('Country')"
                      v-model="account.country"
                      :options="countryList"
                    />
                    <TextField
                      :label="$t('Postal Code')"
                      v-model="account.zip"
                    />
                  </FormLayoutGroup>

                  <validation-provider :name="$t('Phone')" immediate rules="phone" v-slot="{ errors }">
                    <TextField
                      :label="$t('Phone')"
                      v-model="account.phone1"
                      :error="errors[0]"
                    />
                  </validation-provider>

                  <FormLayoutGroup>
                  
                    <validation-provider :name="$t('Support Email')" immediate rules="email" v-slot="{ errors }">
                      <TextField
                        :label="$t('Support Email')"
                        v-model="account.supportEmail"
                        :error="errors[0]"
                      />
                    </validation-provider>

                    <validation-provider :name="$t('Privacy Email')" immediate rules="email" v-slot="{ errors }">
                      <TextField
                        :label="$t('Privacy Email')"
                        v-model="account.privacyEmail"
                        :error="errors[0]"
                      />
                    </validation-provider>
                  </FormLayoutGroup>
                  
                  <validation-provider :name="$t('Website')" immediate rules="url" v-slot="{ errors }">
                    <TextField
                      :label="$t('Website')"
                      v-model="account.website"
                      :error="errors[0]"
                    />
                  </validation-provider>

                  <ImageInput
                    :label="$t('Logo')"
                    :required="true"
                    v-model="account.logoURL"
                  />

                </FormLayout>
              </CardSection>

            </Card>

          </LayoutSection>
        </Layout>

      </Page>
    </ValidationObserver>

  </div>
</template>

<script>

import ImageInput from '../components/ui/ImageInput'
import { extend as ValidateExtend } from 'vee-validate/dist/vee-validate.full'


export default {
  name: 'AccountCompany',
  data () {
    return {
      account: null,
      loading: true,
      saving: false,
      countryList: [],
      formErrors: {}
    }
  },
  mounted() {
    ValidateExtend('url', (value) => {
      if (value && !value.match(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/)) {
        return this.$t('validation.validUrl', { field: '{_field_}' })
      }
      return true
    })

    ValidateExtend('phone', (value) => {
      if (value && !value.match(/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/)) {
        return this.$t('validation.validPhone', { field: '{_field_}' })
      }
      return true
    })

    NProgress.start()
    Promise.all([this.api.getCurrentAccount(), this.api.getCountriesList()])
      .then((data) => {
        const [ account, countryList ] = data
        this.account = account
        this.countryList = countryList
        this.loading = false
      })
      .catch(this.apiCatch)
      .finally(() => {
        NProgress.done()
      })
  },
  methods: {
    save() {
      // window.console.log("saved")
      NProgress.start()
      this.saving = true
      this.api.updateCurrentAccount(this.account)
        .then(() => {
          this.theUser.logoUrl = this.account.logoURL
        })
        .catch(this.apiCatch)
        .finally(() => {
          NProgress.done()
          this.saving = false
          this.theUser.accountName = this.account.name
          this.$ui.toast({ title: this.$t('Account Updated') })
        })
    }
  },
  components: {
    ImageInput
  }
}
</script>

<style lang="scss" scoped>
</style> 